import React, { useEffect, useState } from 'react'
import { getFixturesByDate } from '../../../../api/api_football'
import { addCacheByKey, getCacheByKey } from '../../../../cache/cache'
import { firestore } from '../../../../firebase'
import { dateFormatterFootballApi } from '../../../../helpers/dateFormatter'
import {
    filterFixtures,
    findPlayer,
    getProfferTeamIds,
} from '../../../../helpers/fixturesHelper'
import SingleUtenlandsProffSummary from './SingleUtenlandsProffSummary'

function UtenlandsProfferSummaryByDate() {
    const today = new Date()
    const todayFormattedUTC = dateFormatterFootballApi(today)
    const [date, setDate] = useState(todayFormattedUTC)
    const [fixtures, setFixtures] = useState([])
    const [proffer, setProffer] = useState([])
    const [currentProffer, setCurrentProffer] = useState([])

    async function fetchFixtures(teamIds) {
        const localFixtures = getCacheByKey(`fixtures?d=${date}`)
        if (localFixtures?.fixtures) {
            const fixtures = localFixtures.fixtures
            const proffFixtures = filterFixtures(fixtures, teamIds)
            setFixtures(proffFixtures)
        } else {
            const fixtures = await getFixturesByDate(date)
            const fixturesObj = {
                fixtures: fixtures,
                date_added: new Date(),
            }
            addCacheByKey(`fixtures?d=${date}`, fixturesObj)
            const proffFixtures = filterFixtures(fixtures, teamIds)
            setFixtures(proffFixtures)
        }
    }
    async function fetchProffer() {
        try {
            const proffRef = firestore.collection('utenlandsproffer')
            proffRef.onSnapshot(({ docs }) => {
                const proffer = docs.map((doc) => {
                    return { id: doc.id, ...doc.data() }
                })
                setProffer(proffer)
            })
        } catch (error) {}
    }

    useEffect(() => {
        fetchProffer()
    }, [])

    useEffect(() => {
        console.log(date, proffer, 'DATE CHANGE')
        if (proffer?.length > 0) {
            console.log(date, proffer, 'DATE CHANGE')
            const teamIds = getProfferTeamIds(proffer)
            fetchFixtures(teamIds)
        }
    }, [proffer, date])

    useEffect(() => {
        const profferPlayingToday = fixtures?.map((fixture) => {
            return {
                ...fixture,
                players: findPlayer(
                    fixture.homeTeam.team_id,
                    fixture.awayTeam.team_id,
                    proffer
                ),
            }
        })
        console.log(profferPlayingToday)
        setCurrentProffer(profferPlayingToday)
    }, [fixtures])

    function dateHandler(e) {
        const inputDate = e.target.value
        console.log(inputDate, 'INPUT DATE')
        setDate(inputDate)
    }

    return (
        <div>
            <input
                type="date"
                className="form-control"
                value={date}
                onChange={dateHandler}
            />
            {currentProffer?.map((fixture, index) => (
                <SingleUtenlandsProffSummary key={index} fixture={fixture} />
            ))}
        </div>
    )
}
export default UtenlandsProfferSummaryByDate
